module.exports = __webpack_public_path__ + "static/media/wepik-export-202305240358222afB.24f67ffc.png";